import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

/*
 * Every sick certificate in the practice, for the global Communications page. The
 * tenant-wide endpoint is not paginated (unlike the per-patient one), so the list is
 * returned whole and the table pages through it client-side.
 */
export const usePracticeSickCerts = ({ enabled = true } = {}) => {
  const tenantVal = localStorage.getItem("kinesin-tenant") ?? "";

  return useQuery({
    queryKey: ["practiceSickCerts", tenantVal],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(`${tenantVal}/patientsickcert`);

      return response.data;
    },
    enabled: enabled && !!tenantVal,
    meta: { skipGlobalError: true },
  });
};
